import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {User} from '../../../shared/models/user';
import {HttpHeaders, HttpClient, HttpParams} from '@angular/common/http';
import {SessionService} from '../session/session.service';

@Injectable()
export class UserService {


  constructor(
    private http: HttpClient,
    private sessionService: SessionService
  ) {
  }

  getAuthorizedUsers(): Observable<User[]> {

    const groups = this.sessionService.getPermittedGroupsId();

    const url = `/webofficerpc/rest-endpoint/FeesOffice/users?groupIds=` + groups.join('&groupIds=');

    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.http.get<User[]>(url, {headers});
  }

  getUsers(userIds: number[]): Observable<User[]> {
    const url = `/webofficerpc/rest-endpoint/FeesOffice/users`;

    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    let params = new HttpParams();
    for (const userId of userIds) {
      params = params.append('userIds', userId.toString());
    }

    return this.http.get<User[]>(url, {headers: headers, params: params});
  }
}
